import { createSlice } from '@reduxjs/toolkit';
import { logout } from './authThunk';

const initialState = {
    loggedIn: false,
    loggingOut: false,
    authLoading: false,
    authError: null,
    forceLogout: false,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLoggedIn: (state, action) => {
            state.loggedIn = action.payload;
        },
        setLoggingOut: (state, action) => {
            state.loggingOut = action.payload;
        },
        setAuthLoading: (state, action) => {
            state.authLoading = action.payload;
        },
        setError: (state, action) => {
            state.authError = action.payload;
        },
        setForceLogout: (state, action) => {
            state.forceLogout = action.payload;
        },
        resetState: () => {
            return initialState;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(logout.pending, (state) => {
                state.loggingOut = true;
            })
            .addCase(logout.fulfilled, (state) => {
                state = { ...initialState };
            })
            .addCase(logout.rejected, (state) => {
                state.loggingOut = false;
                state.authError = "Error logging out. Please try again later.";
            });
    }
});

export const {
    setLoggedIn,
    setLoggingOut,
    setAuthLoading,
    setError,
    setForceLogout,
    resetState,
} = authSlice.actions;

export default authSlice.reducer;